import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CustomDialog from "../shared/CustomDialog";
import CloseIcon from "../img/svg/close_blue_new_design.svg";
import { getIsOrthodox } from "../utils/partner";

const HealthDeclarationDialogWOW = ({ open, onClose }) => {
  const { t } = useTranslation();
  const isOrthodox = getIsOrthodox();

  const openWhatsAppOrPhone = () => {
    if (isOrthodox) {
      window.open(`tel:033730300`, "_blank");
      onClose();
    } else {
      window.open(`https://wa.me/0559458809`, "_blank");
      onClose();
    }
  };

  return (
    <CustomDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img src={CloseIcon} alt="close" onClick={onClose} />
          <Typography
            gutterBottom
            sx={{
              fontFamily: `var(--font-family) !important`,
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "28px",
              letterSpacing: "0px",
              color: "#003D62",
              margin: "0px",
              marginBottom: "0px",
            }}
          >
            {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_REQUIRED")}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent>
        <Typography>
          {isOrthodox ? (
            <p className="health-declaration-dialog-text">
              {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_WOW_ORTHODOX_1")}
              <a href="tel:033730300" style={{ color: "#139DEB", textDecoration: "underline" }}>
                03-3730300
              </a>
              {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_WOW_ORTHODOX_2")}
            </p>
          ) : (
            <p className="health-declaration-dialog-text">
              {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_WOW_1")}
              <a href="https://wa.me/0559458809" style={{ color: "#139DEB", textDecoration: "underline" }}>
                055-9458809
              </a>
              {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_WOW_2")}
            </p>
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: 0 }}>
        <Button
          onClick={openWhatsAppOrPhone}
          variant="contained"
          className="health-declaration-dialog-contact-btn"
          sx={{ py: "16px", whiteSpace: "nowrap" }}
        >
          {isOrthodox ? t("PHONE_DIALOG.CONTACT") : t("FREEFIT_CIBUS.CONTACT.WHATSAPP")}
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          className="health-declaration-dialog-close-btn"
          sx={{ py: "16px", whiteSpace: "nowrap" }}
        >
          {t("CLOSE")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default HealthDeclarationDialogWOW;
